import { render, staticRenderFns } from "./overrides.vue?vue&type=template&id=e8dcb6c6&scoped=true&lang=pug&"
import script from "./overrides.vue?vue&type=script&lang=ts&"
export * from "./overrides.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8dcb6c6",
  null
  
)

export default component.exports